import { HStack, Menu, MenuList, Text, VStack } from '@chakra-ui/react'
import { Token, Width } from 'types/chakra'
import { IDropdown } from 'types/common/select'
import { getValidArray } from 'utils/common'
import { DARK_MENU_LIST_PROPS, DARK_TEXT_MUTED, DARK_TEXT_PRIMARY } from 'constants/dark-tokens'
import DropdownButton from './DropdownButton'
import DropdownSelection from './DropdownSelection'

interface IDropdownProps {
  options: IDropdown[]
  name: string
  item?: IDropdown
  setValue: (name: string, value: IDropdown) => void
  width?: Token<Width | number, 'sizes'>
  height?: Token<Width | number, 'sizes'>
  maxWidth?: Token<Width | number, 'sizes'>
  text?: string
  isMatchWidth?: boolean
  isDisabled?: boolean
  fontSize?: string
  titleButton?: string
  titleDropdown?: string
  optionHeight?: Token<Width | number, 'sizes'>
  strategy?: 'fixed' | 'absolute'
  /** Opt-in dark-surface styling for the menu list (default light). */
  dark?: boolean
  /** Trigger chrome overrides, for a dropdown that has to match nearby inputs. */
  border?: string
  background?: string
}

const Dropdown = (props: IDropdownProps) => {
  const {
    options,
    name,
    setValue,
    item,
    width,
    maxWidth,
    text,
    isMatchWidth,
    height,
    optionHeight,
    isDisabled,
    fontSize,
    titleButton,
    titleDropdown,
    dark,
    border,
    background
  } = props
  return (
    <Menu closeOnSelect={true} autoSelect={false} computePositionOnMount matchWidth={isMatchWidth} strategy={props.strategy}>
      {({ isOpen }) => (
        <>
          <DropdownButton
            item={item}
            placeHolder={text}
            isOpen={isOpen}
            width={width}
            height={height}
            fontSize={fontSize}
            isDisabled={isDisabled}
            titleButton={titleButton}
            dark={dark}
            border={border}
            background={background}
          />
          <MenuList
            zIndex="10001"
            maxWidth={maxWidth}
            minWidth="auto"
            {...(dark ? DARK_MENU_LIST_PROPS : { border: '1px solid #E2E8F0' })}
          >
            {titleDropdown && (
              <Text fontSize="xs" paddingX={4} paddingY={1} color={dark ? 'whiteAlpha.600' : 'gray.400'}>
                {titleDropdown}
              </Text>
            )}
            {getValidArray(options).map((option: IDropdown, index: number) => (
              <DropdownSelection
                key={`${name}-${index}`}
                dark={dark}
                onClick={() => setValue(name, option)}
                label={
                  option.description ? (
                    <VStack justifyContent="flex-start" alignItems="flex-start" spacing={0}>
                      <Text fontSize="18px" color={dark ? DARK_TEXT_PRIMARY : 'gray.800'} >
                        {option.title}
                      </Text>
                      <Text fontSize="14px" color={dark ? DARK_TEXT_MUTED : 'gray.500'} >
                        {option.description}
                      </Text>
                    </VStack>
                  ) : (
                    <Text noOfLines={2}>{option.title}</Text>
                  )
                }
                isSelected={option.value === item?.value}
                width={width}
                maxWidth={maxWidth}
                height={optionHeight}
                fontSize={fontSize}
              />
            ))}
          </MenuList>
        </>
      )}
    </Menu>
  )
}

export default Dropdown
